import * as React from 'react';
import { useEffect, useState } from 'react';
import classnames from '../../../core/utils/classnames.tsx';
import { withIcon } from '../../../core/components/Icon.tsx';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import HighlightText, { useKeywordCounts } from './HighlightText.tsx';

const ChevronDownIcon = withIcon(faChevronDown);
const ChevronUpIcon = withIcon(faChevronUp);

interface PretextProps {
    className?: string;
    text: string;
    highlightKeywords: string[];
}

const Pretext = ({ className, text, highlightKeywords }: PretextProps) => {
    const { t } = useTranslation('assistance');

    const [expanded, setExpanded] = useState(false);

    const highlightKeywordCounts = useKeywordCounts(text, highlightKeywords);

    useEffect(() => {
        if (Object.keys(highlightKeywordCounts).length > 0 && !expanded) {
            setExpanded(true);
        }
    }, [highlightKeywordCounts]);

    return (
        <div className={classnames('flex flex-col', className)}>
            <div className="flex flex-col gap-2">
                <div
                    className={classnames(
                        'text-sm overflow-hidden text-content-strong whitespace-pre-line',
                        !expanded && 'max-h-[4rlh]'
                    )}
                >
                    <HighlightText text={text} keywords={highlightKeywords} />
                </div>

                {text?.split('\n').length > 4 && (
                    <div className="flex items-start text-sm font-medium text-content-brand-default hover:text-content-brand-hover">
                        <button className="flex gap-2 rounded items-center" onClick={() => setExpanded(!expanded)}>
                            {expanded
                                ? t('listOfServices.positionCard.showLess')
                                : t('listOfServices.positionCard.showMore')}
                            {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Pretext;
